import type { Invoice } from '../types';

const MONEY_EPSILON = 0.005;

export function activeRelatedDocuments(invoice: Invoice): Invoice[] {
  return (invoice.credit_notes || []).filter(doc => doc.status !== 'cancelled');
}

export function isFullyReversed(invoice: Invoice): boolean {
  const related = activeRelatedDocuments(invoice);
  if (related.some(doc => doc.invoice_type === 'cancellation')) return true;

  const reversedTotal = related.reduce((sum, doc) => sum + Math.abs(parseFloat(doc.total) || 0), 0);
  const invoiceTotal = Math.abs(parseFloat(invoice.total) || 0);

  return invoiceTotal > 0 && reversedTotal >= invoiceTotal - MONEY_EPSILON;
}

export function getEffectiveInvoiceStatus(invoice: Invoice): string {
  return isFullyReversed(invoice) ? 'cancelled' : invoice.status;
}

export function canCancelInvoice(invoice: Invoice): boolean {
  if (invoice.invoice_type !== 'standard') return false;
  return activeRelatedDocuments(invoice).length === 0;
}

export function canCreateCreditNote(invoice: Invoice): boolean {
  if (isFullyReversed(invoice)) return false;

  const related = activeRelatedDocuments(invoice);
  if (related.length === 0) return true;

  const credited = related.reduce((sum, doc) => sum + Math.abs(parseFloat(doc.total) || 0), 0);
  return credited < Math.abs(parseFloat(invoice.total) || 0) - MONEY_EPSILON;
}

export function getPrimaryReversalDocument(invoice: Invoice): Invoice | null {
  const related = activeRelatedDocuments(invoice);
  return related.find(doc => doc.invoice_type === 'cancellation') || related[0] || null;
}
